import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="text-xl font-bold text-background-50 whitespace-nowrap">漫画皮</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              高清好看的网络漫画，尽在漫画皮漫画网。每日更新，免费阅读，为您带来最好的漫画体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">全部漫画</Link>
              <Link to="/category/rexue" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">热血漫画</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/lianai" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/xuanyi" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">悬疑漫画</Link>
              <Link to="/category/qihuan" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">奇幻漫画</Link>
              <Link to="/category/kehuan" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">科幻漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">订阅更新</h4>
            <p className="text-sm text-background-50/60 mb-4">
              订阅漫画皮邮件通知，第一时间获取最新漫画更新信息。
            </p>
            <form
              className="flex flex-col sm:flex-row gap-2"
              id="newsletter-form"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget as HTMLFormElement;
                const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                if (honeypot) {
                  const el = document.getElementById('newsletter-success');
                  if (el) el.style.display = 'block';
                  return;
                }
                const emailInput = form.querySelector('[name="email"]') as HTMLInputElement;
                const email = emailInput?.value;
                if (!email) return;
                const el = document.getElementById('newsletter-success');
                if (el) { el.style.display = 'block'; }
                emailInput.value = '';
              }}
            >
              <div className="flex-1 relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱"
                  className="w-full px-4 py-2.5 text-sm bg-background-50/10 border border-background-50/20 rounded-lg text-background-50 placeholder:text-background-50/30 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 left-[-9999px] top-[-9999px] w-0 h-0"
                />
              </div>
              <button
                type="submit"
                className="px-5 py-2.5 bg-accent-500 text-background-50 rounded-lg text-sm font-medium hover:bg-accent-600 transition-all whitespace-nowrap"
              >
                订阅
              </button>
            </form>
            <p id="newsletter-success" className="text-sm text-green-400 mt-2 hidden">订阅成功！感谢您的关注。</p>
            <p id="newsletter-error" className="text-sm text-red-400 mt-2 hidden"></p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40 whitespace-nowrap">&copy; 2018-2026 漫画皮 qjmd.cn All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-links-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-movie-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-video-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
